/* Google maps */
import $ from 'jquery';

const gmap = (options) => {

	if ( $('.b-map__content').length ) {

		if (!google && !google.maps) return;

		$('.b-map__content').each( (i, element) => {
			const $map = $(element);
			const markers = options.markers;
			const isSimple = !!$map.data('position');
			const position = isSimple ? $map.data('position') : options.activeMarker ? new google.maps.LatLng(markers[options.activeMarker].location[0], markers[options.activeMarker].location[1]) : null;
			const mapOptions = {
				center: position,
				zoom: 9,
				scrollwheel: false
			};

			const markerTypes = [
				{
					url: '/img/bg/marker.png',
					anchor: new google.maps.Point(9, 31)
				}
			];
			const clusterStyles = [{
				url: '/img/bg/cluster.png',
				height: 50,
				width: 50,
				anchor: [0, 0],
				textColor: '#000',
				textSize: 15
			}];
			const map = new google.maps.Map(element, mapOptions);
			let mapMarkers = [];

			if (isSimple) {
				new google.maps.Marker({
					position: $map.data('position'),
					map: map,
					icon: markerTypes[1]
				});
				map.setZoom(15);
			} else {
				var bounds = new google.maps.LatLngBounds();

				$.each(markers, (i, item) => {
					const pos = new google.maps.LatLng(item.location[0], item.location[1]);
					const hasBigMarker = options.activeMarker && i === options.activeMarker;
					const markerOffset = hasBigMarker ? -15 : 15;
					const infoBoxHtml =  `
						<div class="b-map__infobox">
							<a href="#" class="b-map__infobox-close"><span class="icon-svg icon-svg--cross"><svg class="icon-svg__svg icon-svg--cross__svg" xmlns:xlink="http://www.w3.org/1999/xlink"><use xlink:href="../img/bg/icons-svg.svg#icon-cross" x="0" y="0" width="100%" height="100%"></use></svg></span></a>
							<a href="${item.url}" class="b-card">
								${item.img ? '<p class=" b-card__row b-card__row--no-spacing b-card__row--hover-overlay" data-overlay="Zobrazit více">\
									<img src="'+ item.img +'" alt="">\
								</p>' : ''}
								<div class="b-card__row b-card__row--hover-bg">
									<h3 class="b-card__title h5 b-card__title--text b-card__title--hover-arrow" data-icon="→">
										${item.title}
									</h3>
								</div>
								${item.desc ? '<div class="b-card__row">\
									<p>\
										' + item.desc + '\
									</p>\
								</div>' : ''}
								${item.btn ? '<div class="b-card__row b-card__row--dashed b-card__row--thin">\
									<p>\
										<span class="btn btn--block btn--text-after">\
											<span class="btn__text" data-icon="→">' + item.btn + '</span>\
										</span>\
									</p>\
								</div>' : ''}
							</a>
						</div>`;

					if ( !mapOptions.center ){
						bounds.extend(pos);
					}

					let icon = markerTypes[0];

					if (hasBigMarker) {
						icon = markerTypes[1];
					}

					let marker = new google.maps.Marker({
						position: pos,
						map: map,
						icon: icon
					});
					// let infoWindow = new InfoBox({
					// 	content: infoBoxHtml,
					// 	alignBottom: true,
					// 	pixelOffset: new google.maps.Size(-160, markerOffset)
					// });

					// google.maps.event.addListener( marker, 'click', () => {
					// 	infoWindow.open(map, marker);
					// });

					// if (hasBigMarker) {
					// 	google.maps.event.trigger( marker, 'click' );
					// }

					mapMarkers.push(marker);
				});

				if (options.activeMarker) {
					map.setZoom(13);
				}

				//now fit the map to the newly inclusive bounds
				if ( !mapOptions.center ){
					map.fitBounds(bounds);
				}
			}
		});

	}

};


exports.init = gmap;



// WEBPACK FOOTER //
// ./src/js/components/gmap.js